



































































import { Component, Vue, Prop } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import { vxm } from '@/store.vuex';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});
import { ChangePhoneNumberRequest } from '../../models/userdata/changephonenumberrequest';

@Component({
  name: 'UpdatePhoneNumberNew',
  components: {},
})
export default class UpdatePhoneNumberNew extends Vue {
  @Prop() phone;
  @Prop({ default: '' }) countryCode;
  private newPhone: string = '';
  private newPhoneValid: boolean = false;
  private newPhoneNumber: string = '';
  
  $wlToastr: any;

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.newPhoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.newPhoneValid = event.isValid;
  }

  getCompanyCountryCode(): string {
    return vxm.jobs.getCompanyCountryCode;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }
   get totalDropdownHeight() {
    if (!this.supportedCountries) {
      return '217px'; 
    }
    const count = this.supportedCountries.length;
    const calculated = count * 35;
    return calculated > 217 ? '217px' : `${calculated}px`;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }
  get companyName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME')
  }

  async changePhoneNumber() {
    const vm = this;

    if (!this.newPhoneNumber) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.required'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }

    if (!this.newPhoneValid) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.valid'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }
    if (this.phone && this.phone === this.newPhoneNumber) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.duplicate'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }

    var changePhoneNumberRequest = new ChangePhoneNumberRequest();
    changePhoneNumberRequest.newPhone = this.newPhoneNumber;
    const respPromise: any = vxm.users.changePhoneNumber(
      changePhoneNumberRequest,
    );
    const resp = await respPromise;
    if (resp.meta.success) {
      this.$modal.show('emailverificationcode-popup', {
        changePhoneNumberRequest: changePhoneNumberRequest,
        displayMessage: this.$t('sent-activation-link',{companyname:this.companyName,emailid:vxm.users.myUserProfile.email}),
      });
      this.$modal.hide('edit-phone');
    } else {
      vm.$wlToastr(
        'error',
        this.$t('ph-number-already-registered').toString(),
        vm.$t('UserProfile_MyProfile').toString(),
      );
    }
  }
}
